export default {
	sec_01: {
		title: {
			one: 'で決済する',
			two: 'JP WORLD',
			three: 'Pay',
		},
		desc: {
			one: 'お好みの暗号資産を追加して、好きな場所で',
			two: '柔軟なショッピングを体験してください。',
		},
		btn: {
			one: '会員登録',
			two: 'アプリダウンロード',
		},
	},
	sec_02: {
		title: {
			one: '電子マネーにだけある暗号資産を、 JP WORLD PAYを通じて',
			two: 'どこでも買い物を楽しめます。',
		},
		step: {
			one: {
				one: 'でお好きな',
				two: '暗号資産のウォレットを作ってください。',
				three: 'JP WORLD Pay',
			},
			two: {
				one: 'ショッピングのお支払いの際に',
				two: 'JP WORLD Pay',
				three: 'をお選びください。',
			},
			three: {
				one: 'を使い、',
				two: 'お好きな暗号資産でお支払いください。',
				three: 'JP WORLD Pay',
			},
		},
	},
	sec_03: {
		title: {
			one: '繰り返し お楽しみください。',
		},
		desc: {
			one: 'で商品を購入してポイントをもらい',
			two: 'JP WORLD Pay,',
			three: 'そのポイントを使ってまた商品をご購入ください。',
			four: 'JPWORLDPAYポイントは、',
			five: 'を使用するすべての加盟店で使用できます。',
			six: 'JP WORLD Pay.',
		},
	},
	sec_04: {
		title: {
			one: '安心して ご利用してください。',
		},
		desc: {
			one: "JP WORLD Pay's",
			two: 'のセキュリティは世界最高を誇ります。',
			three: 'お客様の個人情報や暗号資産を安全に守り、',
			four: '安心して使用できるようにします。',
		},
	},
};
